import type { FC } from 'react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Chip, Typography } from '@mui/material';

import type { DetailedFollowUpTicket } from 'src/types/followUp';

import { styles } from 'src/components/followUp/TicketOverviewPage/TicketDetail/ticketDetail.styles';

const OrgUnitSection: FC<{ ticket: DetailedFollowUpTicket }> = ({ ticket }) => {
  const { t } = useTranslation('followUp');

  return (
    <Box
      sx={styles.modalSection}
      gap={2}
      component="section"
      aria-label={t('ariaLabel.orgInfo')}
    >
      <Box>
        <Typography component="h5">
          {ticket?.respondent?.name || t('changelog.deletedUser')}
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" gap={1}>
        <Box
          display="flex"
          gap={1}
          flexWrap="wrap"
          alignItems="center"
          aria-label={t('ariaLabel.orgUnitHierarchy')}
        >
          {ticket?.respondent?.orgUnit.map((unit, index) => (
            <Fragment key={unit}>
              {index !== 0 && (
                <Typography
                  fontSize="0.875rem"
                  sx={(theme) => ({ color: theme.colors.neutral[600] })}
                >
                  <ArrowForwardIcon
                    fontSize="inherit"
                    sx={{ verticalAlign: 'middle' }}
                  />
                </Typography>
              )}
              <Chip
                sx={styles.orgUnitChip}
                label={
                  <Typography
                    variant="body4"
                    sx={(theme) => ({ color: theme.colors.neutral[600] })}
                  >
                    {unit}
                  </Typography>
                }
              />
            </Fragment>
          ))}
        </Box>
        <Typography
          variant="body4"
          sx={(theme) => ({ color: theme.colors.neutral[600] })}
        >
          {ticket?.respondent?.email}
        </Typography>
        {ticket?.respondent?.phone && (
          <Typography
            variant="body4"
            sx={(theme) => ({ color: theme.colors.neutral[600] })}
          >
            {ticket.respondent.phone}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default OrgUnitSection;
